import { IconProps, NocIconGenerator } from '../common';

export const Stick = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'Stick',
            path: (
                <>
                    <path
                        d="M3.19974 5.01999L4.06974 6.79999C4.31974 7.30999 4.21974 7.92999 3.81974 8.33999L2.37974 9.82999C1.47974 10.75 2.25974 12.29 3.52974 12.12L5.51974 11.85C6.06974 11.78 6.61974 12.05 6.88974 12.54L7.90974 14.39C8.52974 15.51 10.2097 15.23 10.4297 13.97L10.7997 11.9C10.8997 11.34 11.3397 10.9 11.8997 10.8L13.9697 10.43C15.2297 10.21 15.5097 8.51999 14.3897 7.90999L12.5397 6.88999C12.0497 6.61999 11.7797 6.07999 11.8497 5.51999L12.1197 3.52999C12.2897 2.24999 10.7497 1.47999 9.82974 2.37999L8.33974 3.81999C7.92974 4.21999 7.30974 4.31999 6.79974 4.06999L5.01974 3.19999C3.85974 2.62999 2.63974 3.84999 3.20974 5.00999L3.19974 5.01999Z"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 12L22 22"
                        stroke="#292d32"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            ),
        }}
    />
);
